import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DisableControlDirective } from "./disable-control.directive";

@NgModule({
	declarations: [DisableControlDirective],
	imports: [CommonModule, FormsModule, ReactiveFormsModule],
	exports: [DisableControlDirective],
})
export class DisableControlModule {}
